import React, { useEffect, useState } from "react";
import { BarChart3, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import api from "@/lib/api";
import { TrendChart, PeriodToggle, Metric, VISIT_BARS } from "@/components/analytics/TrendChart";

function Details({ projectId }) {
  const [days, setDays] = useState(7);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/analytics/projects/${projectId}?days=${days}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [projectId, days]);
  return (
    <div className="space-y-4">
      <PeriodToggle value={days} onChange={setDays} prefix="project-analytics" />
      {!data ? <div className="flex justify-center py-10"><Loader2 className="h-5 w-5 animate-spin text-[#0D9488]" /></div>
        : data.error ? <p className="text-sm text-red-600" data-testid="project-analytics-error">Couldn't load analytics.</p>
        : (
          <>
            <div className="grid grid-cols-3 gap-2">
              <Metric label="Page visits" value={data.totals.visits} testId="pa-visits" />
              <Metric label="From QR" value={data.totals.qr_visits} hint="included in visits" testId="pa-qr" />
              <Metric label="Avg daily unique" value={data.totals.avg_daily_unique} hint="estimated, per day" testId="pa-unique" />
            </div>
            <TrendChart data={data.series} bars={VISIT_BARS} testId="project-analytics-chart" />
            <p className="text-xs text-slate-500" data-testid="pa-excluded">Not counted: your own visits, admin/test accounts and automated traffic ({data.excluded.owner_visits + data.excluded.admin_or_test_visitors + data.excluded.bots} in this period).</p>
          </>
        )}
    </div>
  );
}

export function ProjectAnalytics({ project, summary }) {
  return (
    <div className="mt-3 flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2" data-testid={`analytics-summary-${project.id}`}>
      <p className="text-xs text-slate-600">
        {summary ? <><strong className="text-slate-800">{summary.visits}</strong> visits · <strong className="text-slate-800">{summary.qr_visits}</strong> from QR <span className="text-slate-400">· 30 days</span></> : "Visits loading…"}
      </p>
      <Dialog>
        <DialogTrigger asChild>
          <Button size="sm" variant="ghost" className="h-7 px-2 text-xs text-[#0D9488]" data-testid={`analytics-open-${project.id}`}><BarChart3 className="mr-1 h-3.5 w-3.5" />Analytics</Button>
        </DialogTrigger>
        <DialogContent className="max-w-2xl" data-testid="project-analytics-dialog">
          <DialogHeader>
            <DialogTitle className="line-clamp-2 pr-6">{project.title}</DialogTitle>
            <DialogDescription>Private to you. Visitors to your public page never see these numbers.</DialogDescription>
          </DialogHeader>
          <Details projectId={project.id} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
